import {
  signInWithPopup,
  signInWithRedirect,
  type AuthProvider,
  type OAuthProvider,
  type FacebookAuthProvider,
  type GoogleAuthProvider,
} from "firebase/auth";
import { auth, authPersistenceReady } from "../firebase";

const LOCAL_AUTH_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);
const LOCAL_LAN_AUTH_HOST_PATTERN = /^192\.168\.20\.\d{1,3}$/;

export function shouldUseRedirectAuth(hostname = window.location.hostname) {
  return !LOCAL_AUTH_HOSTS.has(hostname) && !LOCAL_LAN_AUTH_HOST_PATTERN.test(hostname);
}

export async function startProviderSignIn(
  provider: GoogleAuthProvider | OAuthProvider | FacebookAuthProvider | AuthProvider,
  hostname = window.location.hostname
) {
  await authPersistenceReady;

  if (shouldUseRedirectAuth(hostname)) {
    await signInWithRedirect(auth, provider);
    return;
  }

  await signInWithPopup(auth, provider);
}
